// extracted by mini-css-extract-plugin
export default {"marquee":"Marquee_marquee__zti0I","track":"Marquee_track__Ixi9T","run":"Marquee_run__4We8y","item":"Marquee_item__NWzvL","mark":"Marquee_mark__84bZk"};